import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authorization/AuthorizationConfig";
import { InteractionStatus } from "@azure/msal-browser";

const LoginPage = () => {
  const { instance, inProgress } = useMsal();

  if (instance && inProgress === InteractionStatus.None) {
    instance.loginRedirect(loginRequest);
  }

  return <div>Logging you in...</div>;
};

export default LoginPage;
